<template>
	<Teleport to="body">
		<div class="modal" :class="{ 'is-active': show }">
			<div class="modal-background" @click="close"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">Login</p>
					<button class="delete" aria-label="close" @click="close"></button>
				</header>
				<section class="modal-card-body">
					<div class="field">
						<label class="label">Login</label>
						<div class="control">
							<input class="input" type="text" v-model="username" autocomplete="username" @keyup.enter="submit" />
						</div>
					</div>
					<div class="field">
						<label class="label">Password</label>
						<div class="control">
							<input class="input" type="password" v-model="password" autocomplete="current-password" @keyup.enter="submit" />
						</div>
					</div>
					<p class="help is-danger" v-if="error">Incorrect username or password.</p>
				</section>
				<footer class="modal-card-foot">
					<button class="button is-success" @click="submit">Log in</button>
					<button class="button" @click="close">Cancel</button>
				</footer>
			</div>
		</div>
	</Teleport>
</template>

<script>
import auth from '@/auth.js';

export default {
	name: 'LoginModal',
	props: { show: Boolean },
	emits: ['close'],
	data() {
		return {
			username: '',
			password: '',
			error: false,
		};
	},
	methods: {
		async submit() {
			const ok = await auth.login(this.username, this.password);
			if (ok) {
				this.error = false;
				this.username = '';
				this.password = '';
				this.$emit('close');
			} else {
				this.error = true;
			}
		},
		close() {
			this.error = false;
			this.username = '';
			this.password = '';
			this.$emit('close');
		},
	},
};
</script>

<style scoped>
.modal {
	z-index: 1000;
}
.modal-card {
	width: 360px;
	max-width: 90vw;
}
</style>
